import { m } from 'framer-motion';

export default function JoinCommunitySVG(props: {
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
  marginBottom?: string;
}) {
  return (
    <svg
      width='120'
      height='115'
      viewBox='0 0 120 115'
      fill='none'
      style={{
        marginTop: props.marginTop,
        marginLeft: props.marginLeft,
        marginRight: props.marginRight,
        marginBottom: props.marginBottom,
      }}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M22.2465 61.6264C22.2465 88.3876 43.9407 110.082 70.7019 110.082C97.4631 110.082 119.157 88.3876 119.157 61.6264C119.157 34.8652 97.4631 13.171 70.7019 13.171C43.9407 13.171 22.2465 34.8652 22.2465 61.6264Z'
        fill='#C5E79F'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M74.7181 76.6096C72.8046 77.2085 66.863 79.1581 63.4203 84.1885C62.8448 85.0293 61.4996 87.0375 62.1914 88.1211C63.0405 89.4506 66.498 88.706 67.8507 88.3201C72.1999 87.0794 85.2211 81.1591 102.456 72.3686C96.3427 72.5665 85.2251 73.3214 74.7181 76.6096Z'
        fill='#081F2D'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M74.7181 76.6096C72.8046 77.2085 66.863 79.1581 63.4203 84.1885C62.8448 85.0293 61.4996 87.0375 62.1914 88.1211C63.0405 89.4506 66.498 88.706 67.8507 88.3201C72.1999 87.0794 85.2211 81.1591 102.456 72.3686C96.3427 72.5665 85.2251 73.3214 74.7181 76.6096Z'
        stroke='#081F2D'
        stroke-width='0.581498'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <mask
        id='mask0_241_872'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='36'
        y='12'
        width='71'
        height='79'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M45.2095 13.1943C44.3233 13.9186 44.1408 15.053 44.0902 15.4023C43.6901 18.183 46.1663 20.8974 50.1774 24.1993C49.6356 23.8143 44.1205 20.0109 41.5983 21.9204C40.6161 22.6699 40.4641 24.0068 40.4184 24.4572C39.8918 29.1672 51.8185 37.5184 59.663 42.4968C50.6335 37.1134 39.8766 31.6743 37.1722 34.6214C36.6456 35.1938 36.5647 35.9332 36.5342 36.2574C36.1492 39.9035 41.9784 42.8056 54.6189 50.7717C51.7017 48.9741 48.3392 47.0089 45.6448 45.7379C44.3179 45.1098 42.0695 44.1425 40.9045 45.0796C40.9045 45.0796 40.3679 45.5097 40.2159 46.4419C39.583 50.2754 55.6976 61.7765 65.0159 73.8497C67.6038 77.1974 71.1742 82.5454 74.1216 90.2534L106.062 87.2248C105.511 85.6245 104.746 83.2037 104.087 80.1957C101.591 68.8059 103.991 64.4861 102.776 54.7474C102.482 52.4074 101.196 43.4436 95.412 34.3533C92.0039 28.995 85.5317 21.2316 82.356 22.5634C80.4673 23.3585 80.1128 27.2025 80.4519 29.6636C80.6749 31.2638 81.2167 32.4794 81.9207 33.5733C77.6515 30.3068 62.889 19.1298 53.7226 14.5972C51.0996 13.3025 48.9299 12.5456 47.3019 12.5459C46.4528 12.5459 45.751 12.7519 45.2095 13.1943Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_241_872)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M45.2095 13.1943C44.3233 13.9186 44.1408 15.053 44.0902 15.4023C43.6901 18.183 46.1663 20.8974 50.1774 24.1993C49.6356 23.8143 44.1205 20.0109 41.5983 21.9204C40.6161 22.6699 40.4641 24.0068 40.4184 24.4572C39.8918 29.1672 51.8185 37.5184 59.663 42.4968C50.6335 37.1134 39.8766 31.6743 37.1722 34.6214C36.6456 35.1938 36.5647 35.9332 36.5342 36.2574C36.1492 39.9035 41.9784 42.8056 54.6189 50.7717C51.7017 48.9741 48.3392 47.0089 45.6448 45.7379C44.3179 45.1098 42.0695 44.1425 40.9045 45.0796C40.9045 45.0796 40.3679 45.5097 40.2159 46.4419C39.583 50.2754 55.6976 61.7765 65.0159 73.8497C67.6038 77.1974 71.1742 82.5454 74.1216 90.2534L106.062 87.2248C105.511 85.6245 104.746 83.2037 104.087 80.1957C101.591 68.8059 103.991 64.4861 102.776 54.7474C102.482 52.4074 101.196 43.4436 95.412 34.3533C92.0039 28.995 85.5317 21.2316 82.356 22.5634C80.4673 23.3585 80.1128 27.2025 80.4519 29.6636C80.6749 31.2638 81.2167 32.4794 81.9207 33.5733C77.6515 30.3068 62.889 19.1298 53.7226 14.5972C51.0996 13.3025 48.9299 12.5456 47.3019 12.5459C46.4528 12.5459 45.751 12.7519 45.2095 13.1943Z'
          fill='url(#paint0_linear_241_872)'
        />
      </g>
      <path
        d='M47.3397 46.2403C49.4492 47.5524 51.874 49.0441 54.6202 50.7743C57.376 52.5105 59.5586 53.9226 60.7459 54.6943'
        stroke='#081F2D'
        stroke-width='0.581498'
      />
      <path
        d='M52.2196 37.4933C57.1918 41.0697 62.389 44.2191 64.8515 45.6843'
        stroke='#081F2D'
        stroke-width='0.581498'
      />
      <path
        d='M47.0381 21.3898C48.3887 22.7553 50.1372 24.2011 52.1588 25.7873C55.8705 28.7 60.9338 32.4246 67.3083 36.4225'
        stroke='#081F2D'
        stroke-width='0.581498'
      />
      <mask
        id='mask1_241_872'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='47'
        y='0'
        width='39'
        height='66'
      >
        <path fill-rule='evenodd' clip-rule='evenodd' d='M47.0673 0H85.0498V65.8364H47.0673V0Z' fill='white' />
      </mask>
      <g mask='url(#mask1_241_872)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M79.9854 65.8363H52.1314C49.3345 65.8363 47.0673 63.5689 47.0673 60.7719V5.06431C47.0673 2.26735 49.3345 -9.15527e-05 52.1314 -9.15527e-05H79.9854C82.7823 -9.15527e-05 85.0498 2.26735 85.0498 5.06431V60.7719C85.0498 63.5689 82.7823 65.8363 79.9854 65.8363Z'
          fill='#FFF2D9'
        />
      </g>
      <path d='M61.2126 3.295H70.9036' stroke='#081F2D' stroke-width='0.581498' />
      <path d='M58.887 61.9599H73.2296' stroke='white' stroke-width='0.581498' />
      <mask
        id='mask2_241_872'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='80'
        y='22'
        width='27'
        height='66'
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M82.3561 22.5633C80.4674 23.3585 80.1129 27.2025 80.452 29.6636C81.0449 33.9226 83.9058 35.4317 86.033 39.3011C87.2434 41.4989 88.3425 44.6897 88.2056 49.3031C88.2056 49.3031 86.5091 49.936 85.0354 51.1413C78.5884 56.4085 80.2446 66.9829 80.4674 68.2892L106.062 87.2248C105.511 85.6245 104.751 83.2037 104.087 80.1957C101.596 68.8059 103.991 64.4858 102.776 54.7474C102.482 52.4074 101.196 43.4436 95.4121 34.3533C92.2664 29.4074 86.51 22.4123 83.1452 22.4123C82.8645 22.4123 82.6006 22.4608 82.3561 22.5633Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask2_241_872)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M82.3561 22.5633C80.4674 23.3585 80.1129 27.2025 80.452 29.6636C81.0449 33.9226 83.9058 35.4317 86.033 39.3011C87.2434 41.4989 88.3425 44.6897 88.2056 49.3031C88.2056 49.3031 86.5091 49.936 85.0354 51.1413C78.5884 56.4085 80.2446 66.9829 80.4674 68.2892L106.062 87.2248C105.511 85.6245 104.751 83.2037 104.087 80.1957C101.596 68.8059 103.991 64.4858 102.776 54.7474C102.482 52.4074 101.196 43.4436 95.4121 34.3533C92.2664 29.4074 86.51 22.4123 83.1452 22.4123C82.8645 22.4123 82.6006 22.4608 82.3561 22.5633Z'
          fill='url(#paint1_linear_241_872)'
        />
      </g>
      <path
        d='M88.2056 49.3031C88.2058 43.5327 87.128 41.2892 86.0329 39.3011C83.906 35.4319 81.0445 33.9228 80.4521 29.6635'
        stroke='#081F2D'
        stroke-width='0.581498'
      />
      <path
        d='M80.4672 68.2893C80.2445 66.9826 78.5885 56.4082 85.0353 51.1413C86.5041 49.9415 88.2055 49.3032 88.2055 49.3032C88.9015 49.023 89.5013 48.853 89.9166 48.7508'
        stroke='#081F2D'
        stroke-width='0.581498'
      />
      <mask
        id='mask3_241_872'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='62'
        y='72'
        width='49'
        height='43'
      >
        <path fill-rule='evenodd' clip-rule='evenodd' d='M62.5745 72.6243H110.594V115H62.5745V72.6243Z' fill='white' />
      </mask>
      <g mask='url(#mask3_241_872)'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M110.594 100.493L66.6618 115C65.6051 105.919 64.4723 99.658 63.8086 95.5084C63.4076 92.9951 62.996 90.4997 62.5745 88.0226C62.5802 88.0397 62.5976 88.0917 62.6196 88.1451C62.6336 88.1908 62.6536 88.2331 62.6736 88.2754C62.6898 88.3114 62.7113 88.3485 62.7304 88.3748C63.5758 89.7023 67.0325 88.96 68.3874 88.5736C72.7358 87.334 85.7564 81.4148 102.993 72.6243L110.594 100.493Z'
          fill='#3B61EB'
        />
      </g>
      <path
        d='M63.6973 94.8118V94.8118C67.1854 95.8088 70.9089 95.5918 74.2573 94.1963L105.343 81.2414'
        stroke='#081F2D'
        stroke-width='0.581498'
      />
      <path
        d='M63.9568 84.4421C63.3813 85.283 62.036 87.2914 62.7278 88.3747C63.5769 89.7042 67.0345 88.9596 68.3871 88.5738C72.7364 87.3331 85.7575 81.4127 102.993 72.6223'
        stroke='#081F2D'
        stroke-width='0.581498'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M36.4933 84.66C33.7844 92.3886 25.3232 96.458 17.5943 93.7492C9.86562 91.0403 5.79629 82.5791 8.50506 74.8502C11.2141 67.1214 19.6754 63.0521 27.4041 65.761C35.1328 68.47 39.2022 76.9313 36.4933 84.66Z'
        fill='#FFCD69'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M27.0935 75.075C27.2799 75.6603 26.9566 76.2859 26.3713 76.4723C25.7861 76.6587 25.1606 76.3353 24.9742 75.7501C24.7878 75.1648 25.1109 74.5392 25.6962 74.3528C26.2815 74.1664 26.9071 74.4898 27.0935 75.075Z'
        fill='#081F2D'
      />
      <path
        d='M27.2688 83.0683C24.979 84.8106 22.0011 85.0169 19.5725 83.8546'
        stroke='#081F2D'
        stroke-width='0.741405'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M20.6345 77.1323C20.8209 77.7176 20.4975 78.3432 19.9123 78.5296C19.327 78.7161 18.7016 78.3926 18.5152 77.8074C18.3287 77.2221 18.6519 76.5965 19.2372 76.4101C19.8224 76.2237 20.4481 76.5471 20.6345 77.1323Z'
        fill='#081F2D'
      />
      <defs>
        <linearGradient
          id='paint0_linear_241_872'
          x1='134.083'
          y1='61.2452'
          x2='80.1305'
          y2='18.0308'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FF5607' />
          <stop offset='1' stop-color='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_241_872'
          x1='102.391'
          y1='91.6785'
          x2='102.391'
          y2='45.2076'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#FF5607' />
          <stop offset='1' stop-color='#FFA700' />
        </linearGradient>
      </defs>
    </svg>
  );
}
